import React from 'react';
import { TablePagination, Paper, Tooltip, Checkbox } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ColumnType } from 'Components/Common/Tables/TableHeaders';
import { pagination } from 'Components/Common/Tables/Tables';
import CustomTable from 'Components/Common/Tables/CustomTable/CustomTable';
import StatusButton from '../../Common/Buttons/StatusButton';
import { convertDate } from 'helpers/dayAndTime';
import OrderTypeArrow from 'Components/Common/Tables/OrderTypeArrow';
import TableFiltering from 'Components/Reusable/TableFiltering/TableFiltering';
import { sortTable } from 'Components/Common/Tables/sortTable';
import FormatCurrency from 'helpers/FormatCurrency';

const DonationTypeList = ({
	trimList,
	reload,
	setReload,
	filterPayload,
	setFilterPayload,
	setTrimList,
	page,
	setPage,
	pageSize,
	setPageSize,
	orderType,
	setOrderType,
	label,
	setLabel,
	setOderBy,
	donationTypes,
	handleOpenEdit,
}: any) => {
	const navigate = useNavigate();

	const handleChangePage = (event: unknown, value: number) => {
		setPage(value);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
		setPageSize(+event.target.value);
		setPage(0);
	};

	const handleEdit = (id: number) => {
		const data = donationTypes?.data?.body.find((item: any) => item.id === id);
		data && handleOpenEdit?.(data);
	};

	const getTableData = () => {
		return donationTypes?.data?.body?.length
			? donationTypes?.data?.body.map((row: any, index: any) => {
					return {
						id: row?.id,
						's/n': page * pageSize + index + 1,
						type: row?.type || 'N/A',
						description: row?.description || 'N/A',
						receipting: <Checkbox checked={row?.receipting} disabled /> ?? 'N/A',
						created: `${row?.created ? convertDate(row?.created) : 'N/A'}`,
						updated: `${row?.updated ? convertDate(row?.updated) : 'N/A'}`,
						createdBy: row?.createdBy?.name || 'N/A',
						updatedBy: row?.updatedBy?.name || 'N/A',
					};
			  })
			: [];
	};

	const getColumnData = () => {
		return trimList.map((column: ColumnType) => {
			return {
				...column,
				data: (
					<>
						<Tooltip title={column.id == 'actions' ? '' : `Sort by ${column.label}`}>
							<span
								style={{ cursor: 'pointer' }}
								onClick={() =>
									sortTable({
										column: column.id,
										setLabel,
										setOderBy,
										setOrderType,
										orderType,
										label,
									})
								}
							>
								{column.label}
								{column.id == label && <OrderTypeArrow orderType={orderType} />}
							</span>
						</Tooltip>
						<>
							<TableFiltering
								field={column.id}
								filterType={column.filterType}
								list={column.list}
								reload={reload}
								setIsReload={setReload}
								setFilterPayload={setFilterPayload}
								filterPayload={filterPayload}
								setPage={setPage}
								page={page}
							/>
						</>
					</>
				),
			};
		});
	};

	const handleDrag = (reOrderedData: ColumnType[]) => {
		reOrderedData && setTrimList?.(reOrderedData);
	};

	const handleResize = (resizedData: ColumnType[]) => {
		resizedData && setTrimList?.(resizedData);
	};

	return (
		<Paper sx={{ width: '100%', overflow: 'hidden' }}>
			<CustomTable
				loading={donationTypes?.loading}
				columnData={getColumnData()}
				tableData={getTableData()}
				handleDrag={handleDrag}
				handleResize={handleResize}
				emptyMessage={'No Donation type available'}
				handleRowClick={(row) => handleEdit(row.id as number)}
			/>
			{(donationTypes?.data?.body?.length as number) > 0 && (
				<TablePagination
					rowsPerPageOptions={[5, 10, 15, 20, 25, 50]}
					component="div"
					count={donationTypes?.data?.totalRecords as number}
					rowsPerPage={pageSize}
					page={page}
					sx={pagination}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			)}
		</Paper>
	);
};

export default DonationTypeList;
